import React from 'react';

const ToolTipText = ({ children , hoverText }) => {
  return (
    <div className="tooltip">
        {hoverText && (
            <span className="tooltiptext">{hoverText}</span>
        )}
      {children}
    </div>
  );
};

export default React.memo(ToolTipText);
